import { render, staticRenderFns } from "./Lszjj.vue?vue&type=template&id=1f348eec&scoped=true&"
import script from "./Lszjj.vue?vue&type=script&lang=js&"
export * from "./Lszjj.vue?vue&type=script&lang=js&"
import style0 from "./Lszjj.vue?vue&type=style&index=0&id=1f348eec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f348eec",
  null
  
)

export default component.exports